import profilePicture from './../images/profilePicture.png';
import { posts } from "../data/posts";

const Home = () => {
  const latestPosts = [...posts]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3);

  return (
    <div>

      {/* HERO SECTION */}
      <div className="hero" style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "60px",
        maxWidth: "1200px",
        margin: "80px auto"
      }}>

        {/* LEFT */}
        <div style={{ flex: 1 }}>

          <h1 className="hero-title" style={{ fontSize: "40px", marginBottom: "20px", fontWeight: "600" }}>
            Architecting scalable AWS systems. Delivering production-ready solutions.
          </h1>

          <p style={{ fontSize: "18px", color: "#555", marginBottom: "20px" }}>
            Certified AWS consultant and senior software engineer with 20+ years of experience.
            I design, build, and optimize cloud-native applications using Java and Python.
          </p>

          <ul style={{ marginBottom: "25px", paddingLeft: "20px", color: "#333" }}>
            <li>AWS Certified (Solutions Architect, DevOps, Security, ML)</li>
            <li>End-to-end delivery: architecture → implementation → optimization</li>
            <li>Production-ready, scalable, and cost-efficient systems</li>
          </ul>

          <div style={{ display: "flex", gap: "15px" }}>
            <a href="/contact" style={{
              padding: "12px 24px",
              background: "#007bff",
              color: "#fff",
              borderRadius: "6px",
              textDecoration: "none",
              fontWeight: "500"
            }}>
              Book a Consultation
            </a>
          </div>
        </div>

        {/* RIGHT */}
        <div style={{ flex: 1 }}>
          <img
            src={profilePicture}
            alt="AWS Consultant"
            style={{
              width: "100%",
              borderRadius: "12px",
              boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
            }}
          />
        </div>
      </div>


      {/* TRUST SECTION */}
      <div style={{ maxWidth: "1200px", margin: "60px auto" }}>
        <h2 style={{ marginBottom: "30px" }}>Why Work With Me</h2>

        <div style={{
          display: "grid",
          gridTemplateColumns: window.innerWidth < 768 ? "1fr" : "repeat(3, 1fr)",
          gap: "30px"
        }}>

          {[
            {
              title: "Certified AWS Expertise",
              text: "AWS certifications across architecture, DevOps, security, and machine learning.",
              link: "who-we-are"
            },
            {
              title: "End-to-End Ownership",
              text: "From initial consulting and PoC to full production deployment and optimization.",
              link: "end-to-end-ownership"
            },
            {
              title: "Production-Focused",
              text: "Real-world systems designed for scalability, reliability, and maintainability.",
              link: "production-focused"
            }
          ].map((item, i) => (
            <a
              key={i}
              href={item.link}
              style={{ textDecoration: "none", color: "inherit" }}
            >
            <div
              key={i}
              style={{
                border: "1px solid #eee",
                borderRadius: "12px",
                padding: "20px",
                background: "#fff",
                transition: "all 0.2s ease"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.08)";
                e.currentTarget.style.transform = "translateY(-2px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <h3 style={{ marginBottom: "10px" }}>{item.title}</h3>
              <p style={{ color: "#555" }}>{item.text}</p>
              <div style={{
                marginTop: "15px",
                fontSize: "14px",
                color: "#007bff",
                fontWeight: "500"
              }}>
                Learn more →
              </div>
            </div>
            </a>
          ))}

        </div>
      </div>

      {/* SERVICES SECTION */}
      <div style={{ maxWidth: "1200px", margin: "60px auto" }}>
        <h2 style={{ marginBottom: "30px" }}>Services</h2>

        <div style={{
          display: "grid",
          gridTemplateColumns: window.innerWidth < 768 ? "1fr" : "repeat(3, 1fr)",
          gap: "30px"
        }}>

          {/* CARD 1 */}
          <a href="/services/aws-architecture" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                padding: "20px",
                border: "1px solid #eee",
                borderRadius: "10px",
                transition: "all 0.2s ease",
                cursor: "pointer",
                height: "100%"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.1)";
                e.currentTarget.style.transform = "translateY(-3px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <h3>AWS Consulting & Architecture</h3>
              <p style={{ color: "#555" }}>
                Design scalable, secure, and cost-efficient cloud architectures.
                From greenfield systems to modernization of existing platforms.
              </p>

              <span style={{ color: "#007bff", fontWeight: "500" }}>
                Learn more →
              </span>
            </div>
          </a>


          {/* CARD 2 */}
          <a href="/services/cloud-development" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                padding: "20px",
                border: "1px solid #eee",
                borderRadius: "10px",
                transition: "all 0.2s ease",
                cursor: "pointer",
                height: "100%"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.1)";
                e.currentTarget.style.transform = "translateY(-3px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <h3>Cloud-Native Development</h3>
              <p style={{ color: "#555" }}>
                Build serverless and event-driven systems using AWS, Java, and Python.
                APIs, microservices, and data pipelines ready for production.
              </p>

              <span style={{ color: "#007bff", fontWeight: "500" }}>
                Learn more →
              </span>
            </div>
          </a>


          {/* CARD 3 */}
          <a href="/services/optimization" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                padding: "20px",
                border: "1px solid #eee",
                borderRadius: "10px",
                transition: "all 0.2s ease",
                cursor: "pointer",
                height: "100%"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.1)";
                e.currentTarget.style.transform = "translateY(-3px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <h3>Optimization & Maintenance</h3>
              <p style={{ color: "#555" }}>
                Improve performance, reduce costs, and enhance reliability of existing AWS systems.
                Monitoring, refactoring, and continuous improvement.
              </p>

              <span style={{ color: "#007bff", fontWeight: "500" }}>
                Learn more →
              </span>
            </div>
          </a>

        </div>
      </div>


      {/* ENGAGEMENT SECTION */}
      <div style={{
        background: "#fafafa",
        padding: "60px 0"
      }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <h2 style={{ marginBottom: "20px" }}>How I Can Help</h2>

          <ul style={{ color: "#555", lineHeight: "1.8" }}>
            <li>✔ AWS consulting sessions</li>
            <li>✔ Proof of Concept (PoC) development</li>
            <li>✔ Full system implementation</li>
            <li>✔ Ongoing support and optimization</li>
          </ul>
        </div>
      </div>


      {/* INSIGHTS SECTION */}
      <div style={{
        padding: "60px 0"
      }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>

          <h2 style={{ marginBottom: "10px" }}>Latest Insights</h2>

          <p style={{ color: "#555", marginBottom: "30px", maxWidth: "700px" }}>
            Deep dives into AWS architecture, real-world implementations, and lessons from production systems.
          </p>

          <div style={{
            display: "grid",
            gridTemplateColumns: window.innerWidth < 768 ? "1fr" : "repeat(3, 1fr)",
            gap: "20px"
          }}>
            {latestPosts.map((post) => (
            <div
              key={post.id}
              style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                overflow: "hidden",
                background: "#fff",
                transition: "all 0.2s ease",
                cursor: "pointer"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.1)";
                e.currentTarget.style.transform = "translateY(-3px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = "none";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >

                {post.image && (
                  <a href={post.link}>
                    <img
                      src={post.image}
                      alt={post.title}
                      style={{
                        width: "100%",
                        height: "180px",
                        objectFit: "contain",
                        backgroundColor: "#f5f5f5",
                        padding: "10px"
                      }}
                    />
                  </a>
                )}

                <div style={{ padding: "15px" }}>
                  <div style={{ fontSize: "12px", color: "#777", marginBottom: "5px" }}>
                    {post.type.toUpperCase()} • {post.date}
                  </div>

                  <h3 style={{ marginBottom: "10px" }}>{post.title}</h3>

                  <p style={{ marginBottom: "10px" }}>{post.summary}</p>

                  <a href={post.link} style={{ color: "#007bff" }}>
                    Read more →
                  </a>
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop: "20px" }}>
            <a href="/insights" style={{ fontWeight: "bold" }}>
              View all insights →
            </a>
          </div>

        </div>
      </div>


      {/* FINAL CTA */}
      <div style={{
        textAlign: "center",
        margin: "100px 0",
        padding: "60px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{
          fontSize: "32px",
          marginBottom: "16px"
        }}>
          Let’s discuss your project
        </h2>

        <p style={{
          color: "#555",
          fontSize: "18px",
          marginBottom: "32px",
          maxWidth: "600px",
          marginLeft: "auto",
          marginRight: "auto",
          lineHeight: "1.6"
        }}>
          Get practical AWS guidance and start building your solution.
        </p>

        <a href="/contact" style={{
          display: "inline-block",
          padding: "16px 36px",
          background: "#007bff",
          color: "#fff",
          borderRadius: "8px",
          textDecoration: "none",
          fontWeight: "500",
          fontSize: "16px",
          transition: "all 0.2s ease",
          boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
        }}
        >
          Schedule a Call
        </a>
      </div>

    </div>
  );
};

export default Home;